






























export default {
    name: "AvisDePrelevementModalPdfViewer",
    props: {
        files: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            selectedPdfIndex: 0,
        };
    },
    methods: {
        selectPdfFile(index: number): void {
            this.selectedPdfIndex = index;
        },
    },
};
